/**
 * Detect in-app / embedded webviews where Google OAuth is blocked
 * (Google returns "disallowed_useragent" and NO account is created, so the
 * orphan monitor cannot even see the attempt - zero trace). Leads opened from
 * email/LinkedIn/WhatsApp on mobile land here. We detect and steer them to
 * email/password or "open in your browser".
 *
 * Patterns matched (substring/regex, case-insensitive):
 *   LinkedIn         LinkedInApp
 *   Instagram        Instagram
 *   Facebook/Msgr    FBAN | FBAV | FB_IAB
 *   WhatsApp         WhatsApp
 *   Line             Line/
 *   WeChat           MicroMessenger
 *   Gmail/Google App GSA/
 *   Snapchat         Snapchat
 *   Android WebView  "; wv"
 */

interface InAppMatch {
  isInApp: boolean;
  matched: string | null;
}

const IN_APP_PATTERNS: Array<{ name: string; re: RegExp }> = [
  { name: "LinkedIn", re: /LinkedInApp/i },
  { name: "Instagram", re: /Instagram/i },
  { name: "Facebook", re: /FBAN|FBAV|FB_IAB/i },
  { name: "WhatsApp", re: /WhatsApp/i },
  { name: "Line", re: /\bLine\//i },
  { name: "WeChat", re: /MicroMessenger/i },
  { name: "Gmail/Google App", re: /GSA\//i },
  { name: "Snapchat", re: /Snapchat/i },
  { name: "Android WebView", re: /;\s*wv\b/i },
];

export function detectInAppBrowser(
  ua: string = typeof navigator !== "undefined" ? navigator.userAgent : ""
): InAppMatch {
  for (const p of IN_APP_PATTERNS) {
    if (p.re.test(ua)) return { isInApp: true, matched: p.name };
  }
  return { isInApp: false, matched: null };
}
